var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7912 5.06054C18.0709 4.93303 17.4093 5.37353 17.2722 6.04731C17.1351 6.7211 17.5962 7.37895 18.2969 7.51081C20.4066 7.90494 22.0356 9.46986 22.4485 11.4985C22.5661 12.0824 23.1025 12.5084 23.7204 12.5084C23.8033 12.5084 23.8862 12.5012 23.9705 12.4867C24.6713 12.3519 25.1324 11.6955 24.9953 11.0203C24.3789 7.99043 21.9452 5.65029 18.7912 5.06054Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6972 0.0114982C18.3596 -0.03487 18.0206 0.0607643 17.7508 0.266523C17.4735 0.47518 17.3003 0.776573 17.2626 1.11419C17.1827 1.79667 17.6966 2.41395 18.4079 2.49075C23.3129 3.01529 27.1255 6.67692 27.677 11.392C27.7509 12.0237 28.3039 12.5005 28.964 12.5005C29.0137 12.5005 29.0619 12.4976 29.1116 12.4918C29.4567 12.4556 29.7642 12.2918 29.9812 12.031C30.1966 11.7702 30.2946 11.4456 30.2554 11.1138C29.5683 5.23081 24.8169 0.664999 18.6972 0.0114982Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6663 15.9099C19.7023 21.6925 21.0717 15.0027 24.9149 18.6829C28.62 22.2324 30.7495 22.9436 26.0551 27.4408C25.4671 27.8936 21.7311 33.3416 8.60161 20.7635C-4.52956 8.18375 1.15239 4.59999 1.62507 4.03668C6.33078 -0.472972 7.06011 1.57956 10.7652 5.12908C14.6084 8.81087 7.63025 10.1274 13.6663 15.9099Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalling);
export default __webpack_public_path__ + "static/media/Calling.ae7628f02c9ae354ea11bc268f3059db.svg";
export { ForwardRef as ReactComponent };